import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-KF3L78F",
  dataLayer: {
    userId: sessionStorage.getItem("lift-username") ? sessionStorage.getItem("lift-username") : 'dev',
  },
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
